import { FC, memo } from "react";
import { IInputFilterProps } from "./inputFilter.props";
import { InputSearch } from "./inputFilter.style";

const InputFilter: FC<IInputFilterProps> = (props: IInputFilterProps) => {
  return <InputSearch {...props} />;
};

export default memo(InputFilter);